import { useSignals } from '@preact/signals-react/runtime';
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';

import { restaurantStore } from '@/entities/restaurant/store/restaurantStore';

dayjs.extend(isoWeek);

export const useWorkTime = () => {
  useSignals();

  const restaurant = restaurantStore.current.value;
  const workingTime = restaurant?.workingTime;

  if (!workingTime) {
    return { opened: true, text: '', style: 'regular' as const };
  }

  const weekdayKey = String(dayjs().isoWeekday());
  const today = workingTime[weekdayKey];

  const open = today?.open_at;
  const close = today?.close_at;

  if (!open || !close) {
    return { opened: true, text: '', style: 'regular' as const };
  }

  const [oh, om = '0'] = open.split(':');
  const [ch, cm = '0'] = close.split(':');

  const startWorkToday = dayjs()
    .hour(parseInt(oh, 10))
    .minute(parseInt(om, 10));
  const endWorkToday = dayjs().hour(parseInt(ch, 10)).minute(parseInt(cm, 10));

  if (dayjs().isBefore(startWorkToday) || !dayjs().isBefore(endWorkToday)) {
    return { text: `закрыто до ${open}`, style: 'red' as const, opened: false };
  }

  if (endWorkToday.diff(dayjs(), 'hours') < 1) {
    return { text: `открыто до ${close}`, style: 'red' as const, opened: true };
  }

  return {
    text: `открыто до ${close}`,
    style: 'regular' as const,
    opened: true,
  };
};
